import PropTypes from 'prop-types';
import { Checkbox, FormControlLabel, FormGroup, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const HealthHabitsSection = ({ formik, headingVariant = 'h5' }) => {
    const { t } = useTranslation();
    return (
        <Stack spacing={0.5}>
            <Typography variant={headingVariant}>
                {t('users.sections.healthHabits')}
            </Typography>
            <FormGroup row sx={{ columnGap: 3, rowGap: 0.5 }}>
                {['smoking', 'alcoholConsumption'].map((field) => (
                    <FormControlLabel
                        key={field}
                        label={t(`users.fields.${field}`)}
                        control={
                            <Checkbox
                                name={field}
                                checked={formik.values[field] === true}
                                onChange={(_, checked) =>
                                    formik.setFieldValue(field, checked)
                                }
                                onBlur={formik.handleBlur}
                                disabled={formik.isSubmitting}
                            />
                        }
                    />
                ))}
            </FormGroup>
        </Stack>
    );
};

HealthHabitsSection.propTypes = {
    formik: PropTypes.object.isRequired,
    headingVariant: PropTypes.oneOf(['h5', 'subtitle1'])
};

export default HealthHabitsSection;
